// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const AlertMessage = t.struct({
    message: t.Any
}, {
    name: 'AlertMessage',
    strict: true
});

export default AlertMessage;



// WEBPACK FOOTER //
// ./src/shared/state/alert-message.js